export const micrositeConfigFileName = "config.json";
